import React from 'react';
import {Text, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';

const CartIdLabel = ({windowWidth}) => {
  const cartId = useSelector(state => state.scanToCart.activeCart?.cart_id);

  return (
    <Text style={[styles.cartId, windowWidth <= 900 && styles.cartIdMobile]}>
      {cartId}
    </Text>
  );
};

const styles = StyleSheet.create({
  cartId: {
    color: '#4D4D4D',
    fontSize: 48,
    fontFamily: 'Poppins_600SemiBold',
    lineHeight: 50
  },
  cartIdMobile: {
    fontSize: 32,
    lineHeight: 36
  }
});

export default CartIdLabel;
